@if (previewUrl(); as url) {
  @if (previewAria(); as ariaLabel) {
    <button
      class="action"
      type="button"
      [attr.aria-label]="ariaLabel"
      [attr.data-test]="previewDataTest() ?? null"
      [attr.data-testid]="previewTestId()"
      (click)="previewRequested.emit()"
    >
      <img class="preview" [src]="url" [alt]="label()" />
    </button>
  } @else {
    <img class="preview" [src]="url" [alt]="label()" />
  }
} @else {
  <ds-icon-attach size="s"></ds-icon-attach>
}

<span class="label">{{ label() }}</span>

<button
  class="action action--remove"
  type="button"
  [attr.aria-label]="removeAria()"
  [attr.data-test]="removeDataTest() ?? null"
  [attr.data-testid]="removeTestId()"
  (click)="removeRequested.emit()"
>
  <ds-icon-close size="s"></ds-icon-close>
</button>
